import type { Locale } from '@fastnorth/i18next';
import { AVAILABLE_LOCALES } from '@fastnorth/i18next';
import { DEFAULT_LOCAL_STORAGE_USER_LOCALE_KEY, DEFAULT_LOCALE } from '../../config/constants';
import storage from '../../lib/storage/localStore';

const getUserLocale = async (): Promise<Locale> => {
  const storedLocale = (await storage.getItem(DEFAULT_LOCAL_STORAGE_USER_LOCALE_KEY)) as Locale;
  if (AVAILABLE_LOCALES[storedLocale] != null) {
    return storedLocale;
  }

  const navigatorLocale = navigator.language as Locale;
  if (AVAILABLE_LOCALES[navigatorLocale] != null) {
    return navigatorLocale;
  }

  return DEFAULT_LOCALE;
};

export default getUserLocale;
